export interface ParsedEventLinks {
  videoLinks: string[];
  otherLinks: string[];
}

// Substrings that identify a video-call URL among the links found in a description.
const VIDEO_LINK_PATTERNS = ['meet.google.com', 'zoom.us/j/', 'teams.microsoft.com'];

const URL_REGEX = /https?:\/\/[^\s<>"')]+/gi;

const isVideoLink = (url: string): boolean =>
  VIDEO_LINK_PATTERNS.some(pattern => url.toLowerCase().includes(pattern));

/**
 * Returns a human-readable platform label for known video-call providers,
 * or null if the URL does not match a known provider.
 */
export const getVideoPlatformLabel = (url: string): string | null => {
  const lowerUrl = url.toLowerCase();
  if (lowerUrl.includes('meet.google.com')) return 'Google Meet';
  if (lowerUrl.includes('zoom.us')) return 'Zoom';
  if (lowerUrl.includes('teams.microsoft.com')) return 'Microsoft Teams';
  return null;
};

/**
 * Extracts the http(s) links contained in an event description and splits them
 * between video-call links (Meet, Zoom, Teams) and other links.
 */
export const parseEventDescription = (description?: string | null): ParsedEventLinks => {
  const matches = description?.match(URL_REGEX) ?? [];

  const cleanedUrls = matches.map(url => url.replace(/[.,;:!?]+$/, ''));
  const uniqueUrls = Array.from(new Set(cleanedUrls));

  const videoLinks: string[] = [];
  const otherLinks: string[] = [];

  uniqueUrls.forEach(url => {
    if (isVideoLink(url)) {
      videoLinks.push(url);
    } else {
      otherLinks.push(url);
    }
  });

  return { videoLinks, otherLinks };
};
